import api from './api';

export const getLessonEngagement = async () => {
  const { data } = await api.get('/educator-analytics/lesson-engagement');
  return data;
};

export const getAssessmentStats = async () => {
  const { data } = await api.get('/educator-analytics/assessment-stats');
  return data;
};

export const getAtRisk = async () => {
  const { data } = await api.get('/educator-analytics/at-risk');
  return data;
};

export default {
  getLessonEngagement,
  getAssessmentStats,
  getAtRisk,
};
